// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b7P4","select":"styles_select__bd9DQ"};